export const mk: Record<string, string> = {
  'app.title': 'Селектирај Отпад',
  'app.subtitle': 'Админ панел',

  'nav.group.operations': 'Оперативно',
  'nav.group.catalog': 'Шифрарници',
  'nav.group.rewards': 'Награди',
  'nav.group.system': 'Систем',
  'nav.dashboard': 'Преглед',
  'nav.appointments': 'Собирања на кеси',
  'nav.bags': 'Побарани кеси',
  'nav.schedules': 'Термини',
  'nav.municipalities': 'Општини',
  'nav.regions': 'Региони',
  'nav.companies': 'Компании',
  'nav.recycleTypes': 'Видови отпад',
  'nav.users': 'Корисници',
  'nav.rewards': 'Поени и исплати',
  'nav.prizeBudgets': 'Буџет за награди',
  'nav.smartBins': 'Smart контејнери',
  'nav.qrCodes': 'QR кодови',
  'nav.audit': 'Дневник на промени',

  'common.save': 'Зачувај',
  'common.cancel': 'Откажи',
  'common.delete': 'Избриши',
  'common.edit': 'Измени',
  'common.create': 'Додај',
  'common.close': 'Затвори',
  'common.search': 'Пребарај',
  'common.actions': 'Акции',
  'common.yes': 'Да',
  'common.no': 'Не',
  'common.confirmDelete': 'Дали сигурно сакате да го избришете записот?',
  'common.saved': 'Зачувано.',
  'common.deleted': 'Избришано.',
  'common.error': 'Настана грешка. Обидете се повторно.',
  'common.offline': 'Серверот не е достапен.',
  'common.loading': 'Се вчитува…',
  'common.noData': 'Нема податоци.',
  'common.refresh': 'Освежи',
  'common.all': 'Сите',
  'common.logout': 'Одјава',
  'common.language': 'Јазик',
  'common.theme': 'Темна/светла тема',
  'common.details': 'Детали',
  'common.from': 'Од',
  'common.to': 'До',
  'common.total': 'Вкупно',
  'common.required': 'Задолжително поле',
  'common.copy': 'Копирај',
  'common.copied': 'Копирано.',
  'common.tableView': 'Табела',

  'login.title': 'Најава',
  'login.email': 'Е-маил',
  'login.password': 'Лозинка',
  'login.submit': 'Најави се',
  'login.forgot': 'Заборавена лозинка?',
  'login.forgotSent': 'Ако постои сметка со тој е-маил, испративме линк за ресетирање.',
  'login.forgotHint': 'Внесете го е-маилот погоре и кликнете повторно.',

  'reset.title': 'Нова лозинка',
  'reset.newPassword': 'Нова лозинка',
  'reset.hint': 'Најмалку 8 знаци, барем една буква и една бројка.',
  'reset.submit': 'Постави лозинка',
  'reset.done': 'Лозинката е променета. Најавете се.',

  'noAccess.title': 'Немате пристап',
  'noAccess.text': 'Вашата сметка нема дозвола за админ панелот. Користете ја мобилната апликација.',

  'field.name': 'Назив',
  'field.regionCode': 'Код на регион',
  'field.languageCode': 'Јазик',
  'field.dateFormat': 'Формат на датум',
  'field.timeFormat': 'Формат на време',
  'field.currencyCode': 'Валута',
  'field.currencySymbol': 'Симбол на валута',
  'field.region': 'Регион',
  'field.isSpecial': 'Специјална (компаниска) локација',
  'field.isGlobal': 'Известувај ги сите членови',
  'field.showSmartBins': 'Smart контејнери',
  'field.allowAwards': 'Награди',
  'field.allowDashboard': 'Дашборд',
  'field.active': 'Активна',
  'field.municipalities': 'Општини',
  'field.color': 'Боја',
  'field.labelHint': 'Лабела во апликацијата',
  'field.showInApp': 'Прикажи во апликацијата',
  'field.allowedForbidden': 'Опис дозволено/недозволено',
  'field.titleAllowed': 'Наслов 1',
  'field.allowed': 'Опис 1',
  'field.titleForbidden': 'Наслов 2',
  'field.forbidden': 'Опис 2',
  'field.titleRules': 'Наслов 3',
  'field.rules': 'Опис 3',
  'field.image': 'Слика',
  'field.date': 'Датум',
  'field.hourFrom': 'Од час',
  'field.hourTo': 'До час',
  'field.municipality': 'Општина',
  'field.location': 'Локација',
  'field.latitude': 'Географска ширина',
  'field.longitude': 'Географска должина',
  'field.email': 'Е-маил',
  'field.fullName': 'Име и презиме',
  'field.role': 'Улога',
  'field.company': 'Компанија',
  'field.address': 'Адреса',
  'field.phone': 'Телефон',
  'field.password': 'Лозинка',
  'field.allowQuality': 'Може да означува квалитет на отпад',
  'field.status': 'Статус',
  'field.code': 'Код',
  'field.codeKind': 'Вид код',
  'field.recycleType': 'Вид отпад',
  'field.collectorKg': 'Кг (собирач)',
  'field.companyKg': 'Кг (компанија)',
  'field.points': 'Поени',
  'field.quality': 'Квалитет',
  'field.user': 'Корисник',
  'field.amount': 'Износ (ден.)',
  'field.note': 'Забелешка',
  'field.prizeType': 'Награда',
  'field.dateFrom': 'Важи од',
  'field.dateTo': 'Важи до',
  'field.numberOfPrizes': 'Број награди',
  'field.winningsInPeriod': 'Добивки во период',
  'field.periodDays': 'Период (денови)',
  'field.numberOfWinnings': 'Досега добиени',
  'field.title': 'Назив',
  'field.progress': 'Пополнетост',
  'field.lastReport': 'Последен извештај',
  'field.createdAt': 'Креирано',
  'field.balance': 'Моментални поени',
  'field.earned': 'Вкупно освоени',
  'field.spent': 'Потрошени',
  'field.bags': 'Кеси',
  'field.rank': 'Ранг',
  'field.kg': 'Кг',
  'field.count': 'Број',
  'field.action': 'Акција',
  'field.actor': 'Корисник',
  'field.entity': 'Запис',
  'field.ip': 'IP адреса',
  'field.type': 'Тип',
  'field.scheduledFor': 'Термин',
  'field.firstScan': 'Прво скенирање',
  'field.confirmedAt': 'Потврдено',

  'role.Admin': 'Администратор',
  'role.SubAdmin': 'Под-администратор',
  'role.User': 'Граѓанин',
  'role.Collector': 'Собирач',
  'role.SuperUserCollector': 'Главен собирач',
  'role.Company': 'Компанија',
  'role.SunilensSpecialAdmin': 'Специјален администратор',

  'status.0': 'Кај корисник',
  'status.1': 'Кај собирач',
  'status.2': 'Успешно во компанија',
  'status.3': 'Неуспешно',
  'status.4': 'Кај собирач (статус)',
  'quality.clean': 'Чист отпад',
  'quality.contaminated': 'Нечист отпад',
  'quality.none': 'Без оценка',
  'codeKind.standard': 'Стандарден',
  'codeKind.special': 'Специјален (повеќекратен)',
  'bagStatus.0': 'Отворено',
  'bagStatus.1': 'Доставено',

  'prize.-1': 'Бонус вртење',
  'prize.0': 'Без награда',
  'prize.5': '5 поени',
  'prize.10': '10 поени',
  'prize.15': '15 поени',
  'prize.20': '20 поени',
  'prize.500': '500 денари',
  'prize.1000': '1000 денари',
  'prize.2000': '2000 денари',
  'prize.3000': '3000 денари',

  'dashboard.title': 'Преглед',
  'dashboard.scope': 'Општина',
  'dashboard.allMunicipalities': 'Сите општини',
  'dashboard.bags': 'Скенирани кеси',
  'dashboard.openBags': 'Чекаат собирање',
  'dashboard.withCollector': 'Кај собирач',
  'dashboard.confirmed': 'Пристигнати во компанија',
  'dashboard.contaminationRate': 'Нечист отпад',
  'dashboard.totalKg': 'Рециклирано (кг)',
  'dashboard.citizens': 'Активни граѓани',
  'dashboard.smartBins': 'Smart контејнери',
  'dashboard.fullBins': 'над 80% полни',
  'dashboard.today': 'Денес',
  'dashboard.scannedToday': 'скенирани',
  'dashboard.confirmedToday': 'потврдени',
  'dashboard.last7': 'Последни 7 дена',
  'dashboard.thisMonth': 'Овој месец',
  'dashboard.kgByType': 'Рециклирани килограми по вид отпад',
  'dashboard.bagsByMonth': 'Потврдени кеси по месец',
  'dashboard.topLocations': 'Најактивни локации',
  'dashboard.recent': 'Последни активности',

  'appointments.title': 'Собирања на кеси',
  'appointments.editTitle': 'Корекција на собирање',
  'appointments.pointsHint': 'Поените во регистарот автоматски се усогласуваат со статусот.',

  'bags.title': 'Побарани кеси',
  'bags.close': 'Означи доставено',
  'bags.closed': 'Барањето е затворено.',

  'schedules.title': 'Термини за собирање',
  'municipalities.title': 'Општини и локации',
  'regions.title': 'Региони',
  'companies.title': 'Компании за рециклирање',
  'companies.links': 'Општини што ги опслужува',
  'companies.linksHint': 'Компанијата гледа и потврдува само кеси од овие општини.',
  'recycleTypes.title': 'Видови отпад',
  'recycleTypes.translations': 'Преводи',
  'recycleTypes.translationsTitle': 'Преводи по регион',
  'recycleTypes.missing': 'Нема превод – видот нема да се прикаже во апликацијата за овој регион.',
  'recycleTypes.upload': 'Прикачи слика',

  'users.title': 'Корисници',
  'users.new': 'Нов корисник',
  'users.edit': 'Измена на корисник',
  'users.changeRole': 'Промени улога',
  'users.setPassword': 'Постави лозинка',
  'users.activate': 'Активирај',
  'users.deactivate': 'Деактивирај',
  'users.inactive': 'Неактивен',
  'users.points': 'Поени',
  'users.ledger': 'Историја на поени',
  'ptx.bag_confirmed': 'Потврдена кеса',
  'ptx.prize_spin': 'Вртење на тркалото',
  'ptx.payment': 'Исплата',
  'users.passwordSet': 'Лозинката е поставена. Сите сесии на корисникот се одјавени.',
  'users.roleChanged': 'Улогата е променета.',

  'rewards.title': 'Поени и исплати',
  'rewards.rankList': 'Ранг листа',
  'rewards.spins': 'Вртења на тркалото',
  'rewards.payments': 'Исплати',
  'rewards.newPayment': 'Нова исплата',
  'rewards.reverse': 'Поништи',
  'rewards.confirmReverse': 'Да се поништи исплатата? Записот се брише, а поените се враќаат на корисникот (копија останува во дневникот на промени).',
  'rewards.wonOnly': 'Само добивки',
  'rewards.pickUser': 'Изберете корисник од ранг листата',
  'prizeBudgets.title': 'Буџет за награди',

  'smartBins.title': 'Smart контејнери',
  'smartBins.keyTitle': 'Клуч на уредот',
  'smartBins.keyText': 'Внесете го овој клуч во уредот (заглавие X-Device-Key или полето SecretKey). Клучот се изведува од SMARTBIN_KEY_SECRET: ако таа тајна се смени, сите уреди добиваат нови клучеви.',
  'smartBins.reports': 'Извештаи',
  'smartBins.ok': 'Успешно',
  'smartBins.failed': 'Неуспешно',

  'qr.title': 'QR кодови за кеси',
  'qr.count': 'Број кодови',
  'qr.kind': 'Вид',
  'qr.generate': 'Генерирај',
  'qr.print': 'Печати',
  'qr.hint': 'Кодовите се потпишани – не можат да се измислат. Стандардните важат еднаш, специјалните се за фиксни локации.',

  'audit.title': 'Дневник на промени',
  'audit.filter': 'Филтер по акција',
  'users.active': 'Активен',
  'users.lockedUntil': 'Заклучен до {date}',
  'smartBins.showKey': 'Клуч за уредот',
  'smartBins.noKeySecret': 'SMARTBIN_KEY_SECRET не е поставен на серверот: уредите можат да пријавуваат само со стариот заеднички клуч.',
  'municipalities.specialHint': 'Специјалните (компаниски) локации имаат негативен id во базата и не се креираат од панелот.',
};
